<template>
    <div>
        <van-cell title="基本设置" is-link @click="toSetting('SiteSettingBase')"/>
<!--        <van-cell title="分销设置" is-link @click="toSetting('SiteSettingSellerReward')"/>-->
        <van-cell title="人员设置" is-link @click="toSetting('SiteSettingUser')"/>
<!--        <van-cell title="修改密码" is-link @click="toSetting('SiteSettingPassword')"/>-->
<!--        <van-cell title="客服管理" is-link @click="toSetting('SiteSettingWxService')"/>-->
<!--        <van-cell title="结算账号管理" is-link @click="toSetting('SiteSettingBank')"/>-->
    </div>
</template>
<style scoped>
</style>

<script>
    import Vue from 'vue';
    import { Cell, CellGroup} from 'vant';

    Vue.use(Cell).use(CellGroup);

    export default {
        name: 'SiteSettingIndex',
        components: {
        },
        data: function () {
            return {
            }
        },
        filter: {},
        mounted() {
            document.title = '省市设置';
        },
        created() {
        },
        methods: {
            toSetting(name) {
                // this.$router.push({name: name})
              rbLink({
                name: name
              })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SiteSettingIndex.vue?a2e09f68